import { cn } from "@/lib/utils";
import { CircleNotch } from "@phosphor-icons/react";
import { Mascot } from "../styleguide/Mascot";

/* Calm shimmer block. */
export function Skeleton({ className }) {
  return <div className={cn("rounded-xl bg-muted motion-safe:animate-pulse", className)} />;
}

/* Skeleton card matching the SubjectCard silhouette. */
export function SkeletonCard() {
  return (
    <div className="rounded-3xl border border-border bg-card p-6 shadow-soft">
      <Skeleton className="h-14 w-14 rounded-2xl" />
      <Skeleton className="mt-4 h-5 w-2/3" />
      <Skeleton className="mt-2 h-4 w-1/2" />
      <Skeleton className="mt-4 h-4 w-full rounded-full" />
    </div>
  );
}

/* List-row skeleton. */
export function SkeletonRow() {
  return (
    <div className="flex items-center gap-4 rounded-3xl border border-border bg-card p-5 shadow-soft">
      <Skeleton className="h-12 w-12 rounded-2xl" />
      <div className="flex-1">
        <Skeleton className="h-4 w-1/2" />
        <Skeleton className="mt-2 h-3 w-1/3" />
      </div>
      <Skeleton className="h-9 w-20 rounded-full" />
    </div>
  );
}

/* Friendly, calm loading card with the mascot. */
export function LoadingCard({ message = "Getting your lesson ready…" }) {
  return (
    <div className="flex flex-col items-center rounded-3xl border border-border bg-card p-8 text-center shadow-soft">
      <Mascot size={88} mood="thinking" />
      <div className="mt-4 flex items-center gap-2 text-primary-strong">
        <CircleNotch size={20} weight="bold" className="motion-safe:animate-spin" />
        <p className="font-display font-extrabold">{message}</p>
      </div>
      <div className="mt-4 flex gap-1.5">
        {[0, 1, 2].map((i) => (
          <span key={i} className="h-2.5 w-2.5 rounded-full bg-primary/40 motion-safe:animate-pulse" style={{ animationDelay: `${i * 0.15}s` }} />
        ))}
      </div>
    </div>
  );
}

/* Inline spinner. */
export function Spinner({ size = 24 }) {
  return <CircleNotch size={size} weight="bold" className="text-primary motion-safe:animate-spin" />;
}
